var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.infoComponent !== null)?_c(_vm.infoComponent,{tag:"component",attrs:{"request":_vm.request}}):_c('div',[_vm._v(" Unknown tenant ")])
}
var staticRenderFns = []

export { render, staticRenderFns }